import type { PlayCategory } from '@frontend/core'
import { CheckboxCardsItem, CheckboxCardsRoot } from '@frontend/ui'
import { useCallback, useMemo } from 'react'
import type { PlayCategoryDef } from '../lib/sport-config'

interface PlayCategoryMenuProps {
  categories: PlayCategoryDef[]
  isCategorySelected: (cat: PlayCategory) => boolean
  toggleCategory: (cat: PlayCategory) => void
}

export function PlayCategorySelection({
  categories,
  isCategorySelected,
  toggleCategory
}: PlayCategoryMenuProps) {
  const selectedCategories = useMemo<PlayCategory[]>(
    () =>
      categories.reduce<PlayCategory[]>((acc, cat) => {
        if (isCategorySelected(cat.category)) acc.push(cat.category)

        return acc
      }, []),
    [categories, isCategorySelected]
  )

  const handleChange = useCallback(
    (_newList: PlayCategory[], cat: PlayCategory) => toggleCategory(cat),
    [toggleCategory]
  )

  return (
    <CheckboxCardsRoot value={selectedCategories} onValueChange={handleChange}>
      {categories.map((cat) => (
        <CheckboxCardsItem value={cat.category}>
          <div className='flex items-center gap-2'>
            <span>{cat.label}</span>
            <span
              className='w-4 h-4 rounded-full'
              style={{ background: cat.color }}
            />
          </div>
        </CheckboxCardsItem>
      ))}
    </CheckboxCardsRoot>
  )
}
